export const MONTH = 'YYYYMM';
export const DATE = 'YYYYMMDD';
export const DATE_WITH_DASH = 'YYYY-MM-DD';
export const DAY = 'DD';
export const FULL_DATE = 'ddd DD-MMM-YYYY';
export const HOUR = 'HH:mm';
export const DATE_AND_TIME = 'YYYYMMDDHH:mm';
export const ISO = 'YYYY-MM-DDTHH:mm:ss Z';
export const FULL_TIME = 'YYYY-MM-DDTHH:mm:ss';
export const TABLE_TIME = 'DD/MM/YYYY';
export const CALENDAR = 'MMMM YYYY';
